// extracted by mini-css-extract-plugin
export default {"app":"App_app__9lg-b","container":"App_container__jO4w5","routerOutlet":"App_routerOutlet__c+g3o"};